import { MapPin, Clock, Phone, Instagram, MessageCircle, Music2 } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { buildWhatsAppUrl } from "@/lib/helpers";

export default function Kontak() {
  const { settings } = useStore();
  const items = [
    { icon: MapPin, label: "Alamat", value: settings?.address },
    { icon: Clock, label: "Jam Operasional", value: settings?.operating_hours },
    { icon: Phone, label: "WhatsApp", value: settings?.whatsapp_number ? `+${settings.whatsapp_number}` : "-" },
    { icon: Instagram, label: "Instagram", value: settings?.instagram ? `@${settings.instagram}` : "-" },
    { icon: Music2, label: "TikTok", value: settings?.tiktok ? `@${settings.tiktok}` : "-" },
  ];

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-10">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">Kontak Kami</h1>
      <p className="mt-2 text-muted-foreground">Punya pertanyaan? Hubungi kami melalui kontak di bawah ini.</p>

      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        {items.map((it) => (
          <div key={it.label} className="flex items-start gap-3 rounded-2xl border border-border bg-card p-5">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent/10 text-accent"><it.icon className="h-5 w-5" /></div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{it.label}</p>
              <p className="mt-0.5 font-medium">{it.value || "-"}</p>
            </div>
          </div>
        ))}
      </div>

      <button
        data-testid="kontak-wa-btn"
        onClick={() => window.open(buildWhatsAppUrl(settings?.whatsapp_number, `Halo Admin ${settings?.store_name}, saya ingin bertanya.`), "_blank")}
        className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-whatsapp py-4 font-bold text-white hover:opacity-90"
      >
        <MessageCircle className="h-5 w-5" /> Chat via WhatsApp
      </button>
    </div>
  );
}
